<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md8>
        <material-card color="purple" title="Edit Profile" text="Complete your profile">
          <v-form>
            <v-container py-0>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field v-model="account.company_name" label="Company" />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field v-model="account.first_name"  label="First Name" class="purple-input" />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field v-model="account.last_name"  label="Last Name" class="purple-input" />
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field v-model="account.address1"  label="Adress" class="purple-input" />
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field v-model="account.city"  label="City" class="purple-input" />
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field v-model="account.state"  label="State" class="purple-input" />
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field v-model="account.postal_code"  class="purple-input" label="Postal Code" type="number" />
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field v-model="account.job_title"  label="Job Title" class="purple-input" />
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field v-model="account.email"  label="Email" class="purple-input" />
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field v-model="account.phone"  label="Phone" class="purple-input" />
                </v-flex>
                <v-flex xs12>
                  <v-textarea v-model="account.about"  class="purple-input" label="About" />
                </v-flex>
                <v-flex xs12 text-xs-right>
                  <v-btn class="mx-0 font-weight-light" @click="updateProfile" color="success">Update Profile</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
      <v-flex xs12 md4>
        <material-card class="v-card-profile">
          <v-avatar slot="offset" class="mx-auto d-block" size="130">
            <img src="https://source.unsplash.com/random" />
          </v-avatar>
          <v-card-text class="text-xs-center">
            <h6 class="category text-gray font-weight-bold mb-3">{{account.company_name}} ({{account.account_external_id}})</h6>
            <h4 class="card-title font-weight-bold">{{account.first_name}} {{account.last_name}}</h4>
            <p
              class="card-description font-weight-light"
            >{{selectedQuote}}</p>
          </v-card-text>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import AccountService from "@/api-services/account.service.js";


export default {
  data: () => ({
	
    //Account items
    account:{},
    quoteSource:[
		{
			quote: "Start by doing what's necessary; then do what's possible; and suddenly you are doing the impossible.",
			name:"Francis of Assisi"
	    },
	    {
	    	quote:"Believe you can and you're halfway there.",
	    	name:"Theodore Roosevelt"
	    },
	    {
	    	quote:"It does not matter how slowly you go as long as you do not stop.",
	    	name:"Confucius"
	    },
	    {
	    	quote:"Our greatest weakness lies in giving up. The most certain way to succeed is always to try just one more time.",
	    	name:"Thomas A. Edison"
	    },
	    {
	    	quote:"The will to win, the desire to succeed, the urge to reach your full potential... these are the keys that will unlock the door to personal excellence.",
	    	name:"Confucius"
	    },
	    {
	    	quote:"Don't watch the clock; do what it does. Keep going.",
	    	name:"Sam Levenson"
	    },
	    {
	    	quote:"A creative man is motivated by the desire to achieve, not by the desire to beat others.",
	    	name:"Ayn Rand"
	    },
	    {
	    	quote:"A creative man is motivated by the desire to achieve, not by the desire to beat others.",
	    	name:"Ayn Rand"
	    },
	    {
	    	quote:"Expect problems and eat them for breakfast.",
	    	name:"Alfred A. Montapert"
	    },
	    {
	    	quote:"Start where you are. Use what you have. Do what you can.",
	    	name:"Arthur Ashe"
	    },
	    {
	    	quote:"Ever tried. Ever failed. No matter. Try Again. Fail again. Fail better.",
	    	name:"Samuel Beckett"
	    },
	    {
	    	quote:"Be yourself; everyone else is already taken.",
	    	name:"Oscar Wilde"
	    },
	    {
	    	quote:"Two things are infinite: the universe and human stupidity; and I'm not sure about the universe.",
	    	name:"Albert Einstein"
	    },
	    {
	    	quote:"Always remember that you are absolutely unique. Just like everyone else.",
	    	name:"Margaret Mead"
	    },
	    {
	    	quote:"Do not take life too seriously. You will never get out of it alive.",
	    	name:"Elbert Hubbard"
	    },
	    {
	    	quote:"People who think they know everything are a great annoyance to those of us who do.",
	    	name:"Isaac Asimov"
	    },
	    {
	    	quote:"Procrastination is the art of keeping up with yesterday.",
	    	name:"Don Marquis"
	    },
	    {
	    	quote:"Get your facts first, then you can distort them as you please.",
	    	name:"Mark Twain"
	    },
	    {
	    	quote:"A day without sunshine is like, you know, night.",
	    	name:"Steve Martin"
	    },
	    {
	    	quote:"My grandmother started walking five miles a day when she was sixty. She's ninety-seven now, and we don't know where the hell she is.",
	    	name:"Ellen DeGeneres"
	    },
	    {
	    	quote:"Don't sweat the petty things and don't pet the sweaty things.",
	    	name:"George Carlin"
	    },
	    {
	    	quote:"Always do whatever's next.",
	    	name:"George Carlin"
	    },
	    {
	    	quote:"Atheism is a non-prophet organization.",
	    	name:"George Carlin"
	    },
	    {
	    	quote:"Hapiness is not something ready made. It comes from your own actions.",
	    	name:"Dalai Lama"
	    }

	]
  }),
  computed: {
    selectedQuote(){
      var sourceLength = this.quoteSource.length;
			var randomNumber= Math.floor(Math.random()*sourceLength);
			//set a new quote
			for(var i=0;i<=sourceLength;i+=1){
			var newQuoteText = this.quoteSource[randomNumber].quote;
      var newQuoteGenius = this.quoteSource[randomNumber].name;
      }
      return newQuoteText+"------"+newQuoteGenius
    }
  },

  watch: {},

  created() {
	  this.setColor("purple");
    this.initialize();
  },

  methods: {
    initialize() {
      var account_external_id="ACCT855239421";
      AccountService.get(account_external_id)
        .then(response => {
          this.account = response.data.account[0];
          console.log(account);
        })
        .catch(error => {
          console.log(error.response.data);
        });
    },
    updateProfile(){
       AccountService.update(
          this.account.account_external_id,
          this.account
        );
	},
	setColor(color) {
      this.$store.state.app.color = color;
    },
  }
};
</script>

<style>
</style>